import React from 'react'
import Link from 'gatsby-link'

const SecondPage = () => (
  <div>
    <div className='Instruction'>
      <div className='InstructionGroup'>
        <h1>Step 5: Postprocess stereotypical autocompleted expressions </h1>
<progress value="100" max="100">100 %</progress>
        <p>* Another way to mitigate algorithmic bias is to remove bias from the predictions. For example, we can prepare two dictionaries of stereotypical words, one for men, and one for women. Gender swapping can be done in a random manner. One example is to replace a stereotypically perceived feminine word (e.g., "nurse") with a stereotypically perceived masculine word (e.g., "doctor").  
        </p>
     <p>* In this case, we swap genders in the original dataset (see below). Any differences noted?
        </p>
        <h2>
          <a href="https://drive.google.com/file/d/1gQJNQb9zMIqrK2-mWQJTAbPe7nGMWc-q/view?usp=sharing" title="Dataset" target="_blank">Dataset</a>
        </h2>   
     <p>* Now run Google Colab below again to see the newly predicted next word given the prompt of either "man" or "woman". After you go to Google Colab, select "Runtime->Run all". Under the section "Gender Swapping", type either "man" or "woman" as the prompt and observe the next word. Repeat the process 10 times, 5 times with the prompt "man", and 5 times with "woman". Any differences noted?
        </p>
        <h2>
          <a href="https://colab.research.google.com/drive/1eO5UQ0YHOt5oIFP6PyZzwb6fsrdhUcxL?usp=sharing" title="Colab" target="_blank">Colab</a>
        </h2>
        <Link to="/4-clean/">Back</Link>	
        <Link to="/">Go back to the homepage</Link>
      </div>
    </div>
  </div>
)

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/5-unawareness.js